import { Entity, type EntityProps } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';

export interface AttackerTypeProps extends EntityProps {
    abbreviation?: string;
    capabilities?: string;
    motiviation?: string;
    typeOfAccess?: string;
    isActor?: boolean;
}

export class AttackerType extends Entity {
    abbreviation?: string;
    capabilities?: string;
    motiviation?: string;
    typeOfAccess?: string;
    isActor?: boolean;

    constructor({
        id,
        name,
        abbreviation,
        capabilities,
        motiviation,
        typeOfAccess,
        isActor,
    }: AttackerTypeProps) {
        super({ id, name });
        this.abbreviation = abbreviation;
        this.capabilities = capabilities;
        this.motiviation = motiviation;
        this.typeOfAccess = typeOfAccess;
        this.isActor = isActor;
    }

    static new({
        name,
        abbreviation,
        capabilities,
        motiviation,
        typeOfAccess,
        isActor,
    }: Omit<AttackerTypeProps, 'id'>): AttackerType {
        return new AttackerType({
            id: new UUID().toString(),
            name,
            abbreviation,
            capabilities,
            motiviation,
            typeOfAccess,
            isActor,
        });
    }
}
